module.exports = __webpack_public_path__ + "static/img/4.6e025f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/4.png
// module id = GRiZ
// module chunks = 0